import {Route, RouteConfig} from "vue-router";
const IssueTrackerIndex = () => import('../views/issue-tracker/IssueTrackerIndex.vue');
const IssueTrackerEdit = () => import('../views/issue-tracker/IssueTrackerEdit.vue');
const IssueTrackerList = () => import('../views/issue-tracker/IssueTrackerList.vue');
const IssueTrackerView = () => import('../views/issue-tracker/IssueTrackerView.vue');

let issueTracker: RouteConfig[] = [
    {
        name: 'issue-tracker',
        path: '/issue-tracker',
        component: IssueTrackerIndex,
        meta: {
            allowLoggedOut: true,
        },
    },
    {
        name: 'issue-tracker-edit',
        path: '/issue-tracker/edit/:id?',
        component: IssueTrackerEdit,
        meta: {
            allowLoggedOut: false,
        },
        props(route: Route)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'issue-tracker-list',
        path: '/issue-tracker/list',
        component: IssueTrackerList,
        meta: {
            allowLoggedOut: true,
        },
    },
    {
        name: 'issue-tracker-view',
        path: '/issue-tracker/view/:id?',
        component: IssueTrackerView,
        meta: {
            allowLoggedOut: true,
        },
        props(route: Route)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
];

export default issueTracker;
